<template>

    <div class="w-100 p-2 d-flex justify-content-center align-items-center bg-light" style="position: absolute;bottom: 0;height:40px">
     
      <img src="../../public/img/eshape.png"  class="" style="width:3%">
      <img src="../../public/img/europe.jpg"  style="margin-left: 10px;width:3%">
      
      <a href="https://e-shape.eu/" class="px-3 text-dark" target="_blank">The e-shape project has received funding from the European Union’s Horizon 2020 research and innovation programme under grant agreement 820852</a>
                        
    </div>

  
</template>
<script>
  export default {}

</script>
<style>

</style>
